import * as i0 from '@angular/core';
import { Injectable, Inject } from '@angular/core';
import * as i2 from '@tangilla/tg-ng-core/src/lib/client-services';
import { HttpClientService } from '@tangilla/tg-ng-core/src/lib/client-services';
import { ServiceHandle } from '@tangilla/tg-ng-models/src/lib/types';
import { CoreServicesModule } from '@tangilla/tg-ng-core/src/lib/core-services';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map, firstValueFrom, mergeMap as mergeMap$1 } from 'rxjs';
import { mergeMap, map as map$1 } from 'rxjs/operators';
import { ServiceHandle as ServiceHandle$1 } from '@tangilla/tg-ng-models';
import * as i2$1 from '@tangilla/tg-ng-core/src/lib/utils';

class PortalConfigApiService extends HttpClientService {
    constructor(http, permissibleHttp, env) {
        super('portal_config', ServiceHandle.ACCOUNT_SERVICE, http, env);
        this.permissibleHttp = permissibleHttp;
    }
    fetchPortalConfig() {
        return this.http.get(this.apiURL());
    }
    permissibleFetchPortalConfig(options) {
        return this.permissibleHttp.get(this.apiURL(), options);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PortalConfigApiService, deps: [{ token: i1.HttpClient }, { token: i2.PermissibleHttpService }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PortalConfigApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PortalConfigApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.PermissibleHttpService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class SessionApiService extends HttpClientService {
    constructor(http, env) {
        super('sessions', ServiceHandle.ACCOUNT_SERVICE, http, env);
    }
    create(body, options) {
        return super.create(body, options)
            .pipe(map((response) => {
            const applications = {};
            const services = {};
            if (response.applications && response.applications.length) {
                response.applications.forEach((application) => {
                    // @ts-ignore
                    applications[application.programming_handle] = application;
                });
            }
            if (response.services && response.services.length) {
                response.services.forEach(service => {
                    // @ts-ignore
                    services[service.programming_handle] = service;
                });
            }
            return {
                super_user: response.super_user,
                user_id: response.user_id,
                time_zone: response.time_zone,
                services_timezone: response.services_timezone,
                applications,
                services
            };
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SessionApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SessionApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SessionApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class UserApiService extends HttpClientService {
    constructor(http, env) {
        super('users', ServiceHandle.ACCOUNT_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class AuthApiService extends HttpClientService {
    constructor(http, permissibleHttp, env) {
        super('auth', ServiceHandle.ACCOUNT_SERVICE, http, env);
        this.permissibleHttp = permissibleHttp;
    }
    getApplicationConfig(applicationName) {
        return this.http.get(`${this.apiURL()}/${applicationName}/application_config`);
    }
    getPermissibleApplicationConfig(applicationName) {
        return this.permissibleHttp.get(`${this.apiURL()}/${applicationName}/application_config`);
    }
    generateToken(applicationName, body) {
        return this.http.post(`${this.apiURL()}/${applicationName}/token`, body)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AuthApiService, deps: [{ token: i1.HttpClient }, { token: i2.PermissibleHttpService }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AuthApiService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AuthApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.PermissibleHttpService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class AmendmentsApiService extends HttpClientService {
    constructor(http, env) {
        super('ammendments', ServiceHandle.BILLING_SERVICE, http, env);
    }
    cancelAmendment(amendmentId) {
        return this.http.delete(`${this.apiServicePath()}/ammendments/${amendmentId}/cancel`)
            .pipe(this.catchHttpError());
    }
    createAmendmentBatch(body, options) {
        return this.http.post(`${this.apiServicePath()}/ammendment_batch`, body, options)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AmendmentsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AmendmentsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AmendmentsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class BillingAssociationSettingsApiService extends HttpClientService {
    constructor(http, env) {
        super('association_settings', ServiceHandle.BILLING_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BillingAssociationSettingsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BillingAssociationSettingsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BillingAssociationSettingsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class ContributionsApiService extends HttpClientService {
    constructor(http, env) {
        super('contributions', ServiceHandle.BILLING_SERVICE, http, env);
    }
    getPersonContributionInvoices(request, personId) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${personId}/invoices`, options).pipe(this.catchHttpError());
    }
    getPersonContributionCsv(personId) {
        return this.http.get(`${this.apiURL()}/${personId}/csv`, { responseType: 'blob' }).pipe(this.catchHttpError());
    }
    getContributionTypes(personId, request) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${personId}/contribution_types`, options).pipe(this.catchHttpError());
    }
    getProductInvoiceItem(personId, request) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${personId}/contribution_types`, options).pipe(this.catchHttpError());
    }
    getContributionsCharges(body, request) {
        return this.http.post(`${this.apiURL()}/charges`, body)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ContributionsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ContributionsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ContributionsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class DriversApiService extends HttpClientService {
    constructor(http, env) {
        super('drivers', ServiceHandle.BILLING_SERVICE, http, env);
    }
    getDriverProductTypes(driverName, relationshipId, params) {
        return this.http.get(`${this.apiURL()}/${driverName}/available_product_types/${relationshipId}`, params)
            .pipe(this.catchHttpError());
    }
    getDriverSubscriptionDetails(driverName, subscriptionId) {
        return this.http.get(`${this.apiURL()}/${driverName}/subscriptions/${subscriptionId}?include_portal_details=true`)
            .pipe(this.catchHttpError());
    }
    getDriverRelationship(driverName, relationshipId) {
        return this.http.get(`${this.apiURL()}/${driverName}/relationships/${relationshipId}`)
            .pipe(this.catchHttpError());
    }
    updateDriverSubscriptionDetails(driverName, subscriptionId, body) {
        return this.http.put(`${this.apiURL()}/${driverName}/subscriptions/${subscriptionId}/details`, body)
            .pipe(this.catchHttpError());
    }
    getDriverDependantSubscriptions(driverName, subscriptionId) {
        return this.http.get(`${this.apiURL()}/${driverName}/subscriptions/${subscriptionId}/dependant_subscriptions`)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DriversApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DriversApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DriversApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class EventBillingTypesApiService extends HttpClientService {
    constructor(http, env) {
        super('event_billing_types', ServiceHandle.BILLING_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EventBillingTypesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EventBillingTypesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EventBillingTypesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class IncidentsApiService extends HttpClientService {
    constructor(http, env) {
        super('incidents', ServiceHandle.BILLING_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IncidentsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IncidentsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IncidentsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class InvoicesApiService extends HttpClientService {
    constructor(http, env) {
        super('invoices', ServiceHandle.BILLING_SERVICE, http, env);
    }
    getInvoicePdf(invoiceId, request) {
        return this.http.get(`${this.apiURL()}/${invoiceId}/pdf`, { responseType: 'blob' })
            .pipe(this.catchHttpError());
    }
    getInvoiceCharges(invoiceId, request) {
        return this.http.get(`${this.apiURL()}/${invoiceId}/charges`)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InvoicesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InvoicesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InvoicesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class BillingOfficesApiService extends HttpClientService {
    constructor(http, env) {
        super('offices', ServiceHandle.BILLING_SERVICE, http, env);
    }
    getInvoices(officeNrdsId, request) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${officeNrdsId}/invoices`, options)
            .pipe(this.catchHttpError());
    }
    getOfficeRoster(officeNrdsId, request) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${officeNrdsId}/roster`, options).pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BillingOfficesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BillingOfficesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BillingOfficesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class PaymentApiService extends HttpClientService {
    constructor(http, env) {
        super('payment', ServiceHandle.BILLING_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PaymentApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PaymentApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PaymentApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class PaymentMethodsApiService extends HttpClientService {
    constructor(http, env) {
        super('payment_methods', ServiceHandle.BILLING_SERVICE, http, env);
    }
    portalUpdate(id, body, options) {
        return this.http.put(`${this.apiURL()}/${id}/portal`, body, options)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PaymentMethodsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PaymentMethodsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PaymentMethodsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class PeopleApiService extends HttpClientService {
    constructor(http, env) {
        super('people', ServiceHandle.BILLING_SERVICE, http, env);
    }
    getPerson(personId, request) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${personId}`, options).pipe(this.catchHttpError());
    }
    getPersonRelationships(request, getAll, personId) {
        return this.http.get(`${this.apiURL()}/${personId}/relationships`, { params: request?.toHttpParams() })
            .pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await firstValueFrom(this.getPersonRelationships(request, getAll, personId));
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    getPersonPayments(request, personId) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${personId}/payments`, options).pipe(this.catchHttpError());
    }
    getPersonAutoPaySettings(personId) {
        return this.http.get(`${this.apiURL()}/${personId}/auto_pay`).pipe(this.catchHttpError());
    }
    updatePersonAutoPaySettings(personId, body) {
        return this.http.post(`${this.apiURL()}/${personId}/auto_pay`, body)
            .pipe(this.catchHttpError());
    }
    getPersonInvoices(request, personId) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${personId}/invoices`, options).pipe(this.catchHttpError());
    }
    getPersonOffices(personId, params) {
        let options = undefined;
        if (params) {
            options = { params };
        }
        return this.http.get(`${this.apiURL()}/${personId}/offices`, options)
            .pipe(this.catchHttpError());
    }
    getPersonAvailableForms(personId, request) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${personId}/available_forms`, options)
            .pipe(this.catchHttpError());
    }
    updatePersonProfile(personId, body) {
        return this.http.put(`${this.apiURL()}/${personId}/profile`, body)
            .pipe(this.catchHttpError());
    }
    createPaymentMethod(personId, body) {
        return this.http.post(`${this.apiURL()}/${personId}/payment_methods`, body)
            .pipe(this.catchHttpError());
    }
    getPersonPaymentMethods(request, personId, getAll) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${personId}/payment_methods`, options).pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await firstValueFrom(this.getPersonPaymentMethods(request, personId, getAll));
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    getPersonUnreportedLicences(request, personId) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${personId}/unreported_licensees`, options).pipe(this.catchHttpError());
    }
    getPaymentDetails(personId) {
        return this.http.get(`${this.apiURL()}/${personId}/payment_details`).pipe(this.catchHttpError());
    }
    getPersonOfficesCorporateStructures(request, personId, query) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        let queryString = '';
        if (query) {
            queryString = '?';
            // @ts-ignore
            queryString += Object.keys(query).map(queryKey => `${queryKey}=${query[queryKey]}`).join('&');
        }
        return this.http.get(`${this.apiURL()}/${personId}/offices_corporate_structures${queryString}`, options).pipe(this.catchHttpError());
    }
    getPersonSubscriptions(personId) {
        return this.http.get(`${this.apiURL()}/${personId}/subscriptions`)
            .pipe(map$1(result => {
            let namesOfOfficesWithSameName = new Set();
            result.items.forEach((subscription) => {
                if (result.items.some((sub) => sub.subscription_id !== subscription.subscription_id && sub.type === subscription.type && sub.office.trim() === subscription.office.trim() && sub.office_nrds_id !== subscription.office_nrds_id)) {
                    namesOfOfficesWithSameName.add(subscription.office);
                }
            });
            result.items = result.items.map(subscription => {
                const incidentsCountString = subscription.incidents_count ?
                    ` <b class="datatable-cell--alert">(${subscription.incidents_count} incident${subscription.incidents_count > 1 ? 's' : ''})</b>` : '';
                subscription.show_status = `${subscription.status}${incidentsCountString}`;
                const amendmentsCountString = subscription.ammendments_count ?
                    ` <b class="datatable-cell--alert">(${subscription.ammendments_count} Amendment${subscription.ammendments_count > 1 ? 's' : ''})</b>` : '';
                subscription.show_role = `${subscription.role}${amendmentsCountString}`;
                if (namesOfOfficesWithSameName.has(subscription.office)) {
                    subscription.office_label = `${subscription.office} (${subscription.office_nrds_id})`;
                }
                else {
                    subscription.office_label = subscription.office;
                }
                return subscription;
            });
            return result;
        }))
            .pipe(this.catchHttpError());
    }
    getCourseRequirements(request, getAll, personId) {
        let options = undefined;
        ;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${personId}/course_requirements`, options)
            .pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await firstValueFrom(this.getCourseRequirements(request, getAll, personId));
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    processAmendmentsInvoice(personId, body) {
        return this.http.post(`${this.apiURL()}/${personId}/process_ammendments_invoice`, body)
            .pipe(this.catchHttpError());
    }
    getDesignatedRealtors(personId, options) {
        return this.http.get(`${this.apiURL()}/${personId}/designated_realtors`, options)
            .pipe(this.catchHttpError());
    }
    getPaginatedPersonCommittees(request, personId) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${personId}/committees`, options).pipe(this.catchHttpError());
    }
    getTransactionHistoryPdf(personId) {
        return this.http.get(`${this.apiURL()}/${personId}/transaction_history_pdf`, { responseType: 'blob' })
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PeopleApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PeopleApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PeopleApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class ProductsApiService extends HttpClientService {
    constructor(http, env) {
        super('products', ServiceHandle.BILLING_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class ProvisioningApiService extends HttpClientService {
    constructor(http, env) {
        super('provisioning', ServiceHandle.BILLING_SERVICE, http, env);
    }
    provisionUnreportedLicensee(body) {
        return this.http.post(`${this.apiURL()}/ul`, body).pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProvisioningApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProvisioningApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProvisioningApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class RecnTransactionApiService extends HttpClientService {
    constructor(http, env) {
        super('recn_transaction', ServiceHandle.BILLING_SERVICE, http, env);
    }
    verifyRecnTransaction(recnRequestId, options) {
        return this.http.get(`${this.apiURL()}/${recnRequestId}/verify`, options)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RecnTransactionApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RecnTransactionApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RecnTransactionApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class RelationshipsApiService extends HttpClientService {
    constructor(http, env) {
        super('relationships', ServiceHandle.BILLING_SERVICE, http, env);
    }
    updateRelationship(relationshipId, body) {
        return this.http.put(`${this.apiURL()}/${relationshipId}`, body)
            .pipe(this.catchHttpError());
    }
    terminateRelationship(relationshipId, body) {
        return this.http.put(`${this.apiURL()}/${relationshipId}/terminate`, body)
            .pipe(this.catchHttpError());
    }
    getRelationshipUserClassOverrides(relationshipId) {
        return this.http.get(`${this.apiURL()}/${relationshipId}/user_class_overrides`)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RelationshipsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RelationshipsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RelationshipsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class SubscriptionsApiService extends HttpClientService {
    constructor(http, env) {
        super('subscriptions', ServiceHandle.BILLING_SERVICE, http, env);
    }
    getLetterOfGoodStanding(subscriptionId) {
        return this.http.get(`${this.apiURL()}/${subscriptionId}/letter_of_good_standing_pdf`, { responseType: 'blob' })
            .pipe(this.catchHttpError());
    }
    getSubscriptionIncidents(request, subscriptionId) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${subscriptionId}/incidents`, options).pipe(this.catchHttpError());
    }
    getSubscriptionAmendments(request, subscriptionId) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${subscriptionId}/ammendments`, options).pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SubscriptionsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SubscriptionsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SubscriptionsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class UnreportedLicenseesApiService extends HttpClientService {
    constructor(http, env) {
        super('unreported_licensees', ServiceHandle.BILLING_SERVICE, http, env);
    }
    getChargesInformation(productType, request) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        const url = (productType === 'LRX') ?
            `${this.apiURL()}/LRX/charges` :
            `${this.apiURL()}/NLX/charges?product_type=${productType}`;
        return this.http.get(url, options).pipe(this.catchHttpError());
    }
    getProductTypes(request) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/product_types`, options).pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UnreportedLicenseesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UnreportedLicenseesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UnreportedLicenseesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class UserClassOverridesApiService extends HttpClientService {
    constructor(http, env) {
        super('user_class_overrides', ServiceHandle.BILLING_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserClassOverridesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserClassOverridesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserClassOverridesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class BillingEntitiesApiService extends HttpClientService {
    constructor(http, env) {
        super('billing_entities', ServiceHandle.BILLING_SERVICE, http, env);
    }
    getPaginatedBillingEntities(request, getAll, url) {
        return super.getPaginated(request, getAll, url)
            .pipe(map$1((data) => {
            for (const billingEntity of data.items) {
                billingEntity.contact_full_name = `${billingEntity.contact_first_name} ${billingEntity.contact_last_name}`;
            }
            return data;
        }));
    }
    getBillingEntityInvoices(request, getAll, billingEntityId) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${billingEntityId}/invoices`, options).pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await firstValueFrom(this.getBillingEntityInvoices(request, getAll, billingEntityId));
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    getBillingEntityInvoicesSum(request, billingEntityId) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${billingEntityId}/invoices/sum`, options).pipe(this.catchHttpError());
    }
    getBillingEntityHasMissingPreparedPayments(billingEntityId) {
        return this.http.get(`${this.apiURL()}/${billingEntityId}/has_missing_prepared_payments`)
            .pipe(this.catchHttpError());
    }
    getBillingEntityPaymentsSummary(request, getAll, billingEntityId) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${billingEntityId}/payments_summary`, options).pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await firstValueFrom(this.getBillingEntityPaymentsSummary(request, getAll, billingEntityId));
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BillingEntitiesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BillingEntitiesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BillingEntitiesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class PreparedPaymentsApiService extends HttpClientService {
    constructor(http, env) {
        super('prepared_payments', ServiceHandle.BILLING_SERVICE, http, env);
    }
    getPreparedPaymentItems(request, preparedPaymentId) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${preparedPaymentId}/prepared_payment_items`, options)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreparedPaymentsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreparedPaymentsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreparedPaymentsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class NonInvoicedProductsApiService extends HttpClientService {
    constructor(http, env) {
        super('nips', ServiceHandle$1.BILLING_SERVICE, http, env);
    }
    getNonInvoicedProductReceiptItems(request, getAll, nipId) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        const productTypeUrl = `${this.apiURL()}/${nipId}/nip_receipt_items`;
        return this.http.get(productTypeUrl, options)
            .pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await this.getNonInvoicedProductReceiptItems(request, getAll, nipId).toPromise();
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    getProductBillPeriods(request, getAll, nipId) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        const productTypeUrl = `${this.apiURL()}/${nipId}/bill_periods`;
        return this.http.get(productTypeUrl, options)
            .pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await this.getProductBillPeriods(request, getAll, nipId).toPromise();
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    downloadProductSetupSummary(productId, billRunId) {
        let productSetupSummaryUrl = `${this.apiURL()}/${productId ? productId : null}/nip_setup_summary`;
        if (billRunId) {
            productSetupSummaryUrl += `?bill_run_id=${billRunId}`;
        }
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http.get(productSetupSummaryUrl, { headers, responseType: 'blob' })
            .pipe(this.catchHttpError());
    }
    createNonInvoicedProductReceiptItem(nipId, body, options) {
        return this.http.post(`${this.apiURL()}/${nipId}/nip_receipt_items`, body, options)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NonInvoicedProductsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NonInvoicedProductsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NonInvoicedProductsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class ProductConfigNonInvoicedProductsApiService extends HttpClientService {
    constructor(http, env) {
        super('product_config/nips', ServiceHandle$1.BILLING_SERVICE, http, env);
    }
    getProductTypes(request, getAll, nipId) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        const productTypeUrl = `${this.apiURL()}/${nipId}/product_types`;
        return this.http.get(productTypeUrl, options)
            .pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await this.getProductTypes(request, getAll, nipId).toPromise();
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    getNonInvoicedProductBillTypes(request, getAll, nipId) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        const productTypeUrl = `${this.apiURL()}/${nipId}/bill_types`;
        return this.http.get(productTypeUrl, options)
            .pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await this.getNonInvoicedProductBillTypes(request, getAll, nipId).toPromise();
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductConfigNonInvoicedProductsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductConfigNonInvoicedProductsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductConfigNonInvoicedProductsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class PreparedPaymentInvoicesApiService extends HttpClientService {
    constructor(http, env) {
        super('prepared_payment_invoices', ServiceHandle.BILLING_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreparedPaymentInvoicesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreparedPaymentInvoicesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreparedPaymentInvoicesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class LocalAssociationsApiService extends HttpClientService {
    constructor(http, env) {
        super('local_associations', ServiceHandle.BILLING_SERVICE, http, env);
    }
    getLocalAssociationInvoices(request, getAll, localAssociationNrdsId) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        const productTypeUrl = `${this.apiURL()}/${localAssociationNrdsId}/invoices`;
        return this.http.get(productTypeUrl, options)
            .pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await this.getLocalAssociationInvoices(request, getAll, localAssociationNrdsId).toPromise();
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LocalAssociationsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LocalAssociationsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LocalAssociationsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class AssociationPaymentItemsApiService extends HttpClientService {
    constructor(http, env) {
        super('association_payment_items', ServiceHandle.BILLING_SERVICE, http, env);
    }
    getAssociationPaymentItemReceipts(request, getAll, associationPaymentId) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${associationPaymentId}/payments_summary`, options).pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await firstValueFrom(this.getAssociationPaymentItemReceipts(request, getAll, associationPaymentId));
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    reallocateAssociationPaymentItem(associationPaymentItemId, body, params) {
        return this.http.post(`${this.apiURL()}/${associationPaymentItemId}/reallocate`, body, params)
            .pipe(this.catchHttpError());
    }
    getInvoiceCreditActivity(associationPaymentItemId) {
        return this.http.get(`${this.apiURL()}/${associationPaymentItemId}/invoice_credit_activity`)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AssociationPaymentItemsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AssociationPaymentItemsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AssociationPaymentItemsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class AssociationPaymentsApiService extends HttpClientService {
    constructor(http, env) {
        super('association_payments', ServiceHandle.BILLING_SERVICE, http, env);
    }
    getAssociationPaymentItems(request, getAll, associationPaymentId) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${associationPaymentId}/association_payment_items`, options).pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await firstValueFrom(this.getAssociationPaymentItems(request, getAll, associationPaymentId));
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    getAssociationPaymentItemsCountsByStatus(request, associationPaymentId) {
        return this.http.get(`${this.apiURL()}/${associationPaymentId}/association_payment_items_counts_by_status`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AssociationPaymentsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AssociationPaymentsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AssociationPaymentsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class PeopleLookupApiService extends HttpClientService {
    constructor(http, env) {
        super('people_lookup', ServiceHandle$1.BILLING_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PeopleLookupApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PeopleLookupApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PeopleLookupApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class ValidateMemberNRDSIDApiService extends HttpClientService {
    constructor(http, env) {
        super('validate_member_nrds_id', ServiceHandle.BILLING_SERVICE, http, env);
        this._lastMemberSearches = {};
    }
    get lastMemberSearch() {
        return this._lastMemberSearch;
    }
    setLastMemberSearch(data) {
        this._lastMemberSearch = data;
    }
    setLastMemberSearchesByKey(key, data) {
        this._lastMemberSearches[key] = data;
    }
    setLastMemberSearches(data) {
        this._lastMemberSearches = data;
    }
    get lastMemberSearches() {
        return this._lastMemberSearches;
    }
    getLastMemberInSearchesByIndex(index) {
        return this._lastMemberSearches[index];
    }
    getLastMemberNRDSIDSearched(index) {
        const lastMemberSearchedByIndex = this.getLastMemberInSearchesByIndex(index);
        if (lastMemberSearchedByIndex && lastMemberSearchedByIndex.first_name) {
            return `${lastMemberSearchedByIndex.first_name}${lastMemberSearchedByIndex.last_name ? ` ${lastMemberSearchedByIndex.last_name}` : ''}`;
        }
        return null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ValidateMemberNRDSIDApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ValidateMemberNRDSIDApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ValidateMemberNRDSIDApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class CreditRequestsApiService extends HttpClientService {
    constructor(http, env) {
        super('credit_requests', ServiceHandle.BILLING_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditRequestsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditRequestsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CreditRequestsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class OfficeMembersApiService extends HttpClientService {
    constructor(http, env) {
        super('office_members', ServiceHandle.BILLING_SERVICE, http, env);
    }
    getOfficeMembers(memberNrdsId) {
        return this.http.get(`${this.apiURL()}?member_nrds_id=${memberNrdsId}`)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OfficeMembersApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OfficeMembersApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OfficeMembersApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class GeneralLedgersApiService extends HttpClientService {
    constructor(http, env) {
        super('general_ledgers', ServiceHandle.BILLING_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: GeneralLedgersApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: GeneralLedgersApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: GeneralLedgersApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class BillingEntityUsersApiService extends HttpClientService {
    constructor(http, env) {
        super('billing_entity_users', ServiceHandle.BILLING_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BillingEntityUsersApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BillingEntityUsersApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BillingEntityUsersApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class ApplicationsApiService extends HttpClientService {
    constructor(http, env) {
        super('applications', ServiceHandle.BILLING_SERVICE, http, env);
    }
    getAvailableMembershipTypes(body) {
        return this.http.post(`${this.apiURL()}/available_membership_types`, body)
            .pipe(this.catchHttpError());
    }
    getRole(body, type) {
        return this.http.post(`${this.apiURL()}/role?type=${type}`, body)
            .pipe(this.catchHttpError());
    }
    getApplicationCharges(body) {
        return this.http.post(`${this.apiURL()}/charges`, body)
            .pipe(this.catchHttpError());
    }
    getValidateTransitionRequired(body) {
        return this.http.post(`${this.apiURL()}/validate_transition_required`, body)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class ProductTypeCatalogApiService extends HttpClientService {
    constructor(http, env) {
        super('product_type_catalog', ServiceHandle.BILLING_SERVICE, http, env);
    }
    // /product_type_catalog/{role_code}?queryParams
    getProductTypeCatalogForRoleCode(roleCode, queryParams) {
        return this.http.get(`${this.apiURL()}/${roleCode}`, { params: queryParams })
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductTypeCatalogApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductTypeCatalogApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProductTypeCatalogApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class FindPersonApiService extends HttpClientService {
    constructor(http, env) {
        super('find_person', ServiceHandle.BILLING_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FindPersonApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FindPersonApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FindPersonApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class FormsBillingApiService extends HttpClientService {
    constructor(http, env) {
        super('forms', ServiceHandle.BILLING_SERVICE, http, env);
    }
    getFormCharges(body) {
        return this.http.post(`${this.apiURL()}/charges`, body)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormsBillingApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormsBillingApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormsBillingApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class ValidateDuesPaymentsApiService extends HttpClientService {
    constructor(http, env) {
        super('validate_dues_payments', ServiceHandle.BILLING_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ValidateDuesPaymentsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ValidateDuesPaymentsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ValidateDuesPaymentsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class OfficeRosterApiService extends HttpClientService {
    constructor(http, env) {
        super('offices', ServiceHandle.BILLING_SERVICE, http, env);
    }
    getRoster(officeNrdsId, options) {
        return this.http.get(`${this.apiURL()}/${officeNrdsId}/roster`, options)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OfficeRosterApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OfficeRosterApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OfficeRosterApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class AddendumsApiService extends HttpClientService {
    constructor(http, env) {
        super('addendums', ServiceHandle.BEAN_COUNTER_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AddendumsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AddendumsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AddendumsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class BeanCounterInvoicesApiService extends HttpClientService {
    constructor(http, env) {
        super('invoices', ServiceHandle.BEAN_COUNTER_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BeanCounterInvoicesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BeanCounterInvoicesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BeanCounterInvoicesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class CustomersApiService extends HttpClientService {
    constructor(http, env) {
        super('customers', ServiceHandle.BEAN_COUNTER_SERVICE, http, env);
    }
    getCustomerMsas(request, getAll, customerId) {
        return this.http.get(`${this.apiURL()}/${customerId}/msas`, { params: request?.toHttpParams() })
            .pipe(mergeMap$1(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await firstValueFrom(this.getCustomerMsas(request, getAll, customerId));
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    createCustomerMsa(customerId, body, options) {
        return this.http.post(`${this.apiURL()}/${customerId}/msas`, body, options)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CustomersApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CustomersApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CustomersApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class MsasApiService extends HttpClientService {
    constructor(http, env) {
        super('msas', ServiceHandle.BEAN_COUNTER_SERVICE, http, env);
    }
    getMsaAddendums(request, getAll, msaId) {
        return this.http.get(`${this.apiURL()}/${msaId}/addendums`, { params: request?.toHttpParams() })
            .pipe(mergeMap$1(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await firstValueFrom(this.getMsaAddendums(request, getAll, msaId));
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    createMsaAddendum(msaId, body, options) {
        return this.http.post(`${this.apiURL()}/${msaId}/addendums`, body, options)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MsasApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MsasApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MsasApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class ItemTypesApiService extends HttpClientService {
    constructor(http, env) {
        super('item_types', ServiceHandle.BEAN_COUNTER_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ItemTypesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ItemTypesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ItemTypesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class XeroContactsApiService extends HttpClientService {
    constructor(http, env) {
        super('xero/contacts', ServiceHandle.BEAN_COUNTER_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: XeroContactsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: XeroContactsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: XeroContactsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class AttendancesApiService extends HttpClientService {
    constructor(http, env) {
        super('attendance', ServiceHandle.COMMITTEE_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AttendancesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AttendancesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AttendancesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class CommitteesApiService extends HttpClientService {
    constructor(http, env) {
        super('committees', ServiceHandle.COMMITTEE_SERVICE, http, env);
    }
    getCommitteeRoster(committeeId, request) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        const url = `${this.env.api.committee}/${this.apiPath}/${committeeId}/members`;
        return this.http.get(url, options)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CommitteesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CommitteesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CommitteesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class CommitteesPeopleApiService extends HttpClientService {
    constructor(http, env) {
        super('people', ServiceHandle.COMMITTEE_SERVICE, http, env);
    }
    getPersonCommittees(personId, request) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${personId}/committees`, options)
            .pipe(this.catchHttpError());
    }
    getPersonMeetings(personId, request) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${personId}/meetings`, options)
            .pipe(this.catchHttpError());
    }
    getPersonAttendancesCount(personId, options) {
        return this.http.get(`${this.apiURL()}/${personId}/attendances/count`, options)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CommitteesPeopleApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CommitteesPeopleApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CommitteesPeopleApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class MeetingsApiService extends HttpClientService {
    constructor(http, env) {
        super('meetings', ServiceHandle.COMMITTEE_SERVICE, http, env);
    }
    getMeetingFile(meetingId, fileName) {
        return this.http.get(`${this.apiURL()}/${meetingId}/files/${fileName}`, { responseType: 'blob' })
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MeetingsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MeetingsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MeetingsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class TermsApiService extends HttpClientService {
    constructor(http, env) {
        super('terms', ServiceHandle.COMMITTEE_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TermsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TermsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TermsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class OptoutsApiService extends HttpClientService {
    constructor(http, env) {
        super('optouts', ServiceHandle.COMMUNICATION_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OptoutsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OptoutsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OptoutsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class PortalFormsApiService extends HttpClientService {
    constructor(http, env) {
        super('portal_forms', ServiceHandle.COMMUNICATION_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PortalFormsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PortalFormsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PortalFormsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class PortalMessagesApiService extends HttpClientService {
    constructor(http, env) {
        super('portal_messages', ServiceHandle.COMMUNICATION_SERVICE, http, env);
    }
    getPortalMessages(request) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        const url = `${this.apiURL()}`;
        return this.http.get(url, options)
            .pipe(mergeMap(async (data) => {
            if (request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await this.getPaginated(request, true, url).toPromise();
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PortalMessagesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PortalMessagesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PortalMessagesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class PortalTilesApiService extends HttpClientService {
    constructor(http, env) {
        super('portal_tiles', ServiceHandle.COMMUNICATION_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PortalTilesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PortalTilesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PortalTilesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class UnsubscribeApiService extends HttpClientService {
    constructor(http, env) {
        super('unsubscribe', ServiceHandle.COMMUNICATION_SERVICE, http, env);
    }
    create(id, body, options) {
        return this.http.post(`${this.apiURL()}/${id}`, body, options)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UnsubscribeApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UnsubscribeApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UnsubscribeApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class EmailApiService extends HttpClientService {
    constructor(http, env) {
        super('suppression_list', ServiceHandle.EMAIL_SERVICE, http, env);
    }
    deleteFromSuppressionList(type) {
        return this.http.delete(`${this.apiURL()}/${type}`)
            .pipe(this.catchHttpError());
    }
    getFromSuppressionList() {
        const type = 'any';
        return this.http.get(`${this.apiURL()}/${type}`)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EmailApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EmailApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EmailApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class BookingsApiService extends HttpClientService {
    constructor(http, env) {
        super('bookings', ServiceHandle.EVENT_SERVICE, http, env);
    }
    getBundlesBookings() {
        return this.http.get(`${this.apiURL()}/bundles`)
            .pipe(this.catchHttpError());
    }
    getPaginatedBookingRsvps(bookingId, request, getAll) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${bookingId}/rsvps`, options)
            .pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await firstValueFrom(this.getPaginatedBookingRsvps(request, getAll));
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }), this.catchHttpError());
    }
    getBookingCharges(chargesPayload, options) {
        return this.http.post(`${this.apiServicePath()}/charges`, chargesPayload, options)
            .pipe(this.catchHttpError());
    }
    validateBooking(bookingPayload, options) {
        return this.http.post(`${this.apiURL()}/validate`, bookingPayload, options)
            .pipe(this.catchHttpError());
    }
    create(body, options) {
        return this.http.post(this.apiURL(), body, options)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BookingsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BookingsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BookingsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class BundlesApiService extends HttpClientService {
    constructor(http, env) {
        super('bundles', ServiceHandle.EVENT_SERVICE, http, env);
    }
    getBundleDetails(bundleId) {
        return this.http.get(`${this.apiURL()}/${bundleId}/details`)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BundlesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BundlesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BundlesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class CalendarEventsApiService extends HttpClientService {
    constructor(http, env) {
        super('calendar_events', ServiceHandle.EVENT_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CalendarEventsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CalendarEventsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CalendarEventsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class CoursesApiService extends HttpClientService {
    constructor(http, env) {
        super('courses', ServiceHandle.EVENT_SERVICE, http, env);
    }
    getCourseClasses(courseId, options) {
        return this.http.get(`${this.apiURL()}/${courseId}/course_classes`, options)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CoursesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CoursesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CoursesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class CoursesOnDemandApiService extends HttpClientService {
    constructor(http, env) {
        super('courses_on_demand', ServiceHandle.EVENT_SERVICE, http, env);
    }
    getActiveCourses(params) {
        let options = undefined;
        if (params) {
            options = { params };
        }
        return this.http.get(`${this.apiURL()}/active_courses`, options).pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CoursesOnDemandApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CoursesOnDemandApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CoursesOnDemandApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class EventPeopleApiService extends HttpClientService {
    constructor(http, env) {
        super('people', ServiceHandle.EVENT_SERVICE, http, env);
    }
    getPaginatedCompletedCourses(request, personId) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${personId}/courses/completed_courses`, options).pipe(this.catchHttpError());
    }
    getPersonRsvps(personId, request, getAll) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${personId}/rsvps`, options).pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await firstValueFrom(this.getPersonRsvps(personId, request, getAll));
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EventPeopleApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EventPeopleApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EventPeopleApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class EventsApiService extends HttpClientService {
    constructor(http, env) {
        super('events', ServiceHandle.EVENT_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EventsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EventsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EventsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class EventsAssociationSettingsApiService extends HttpClientService {
    constructor(http, env) {
        super('association_settings', ServiceHandle.EVENT_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EventsAssociationSettingsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EventsAssociationSettingsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EventsAssociationSettingsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class IntegrationsApiService extends HttpClientService {
    constructor(http, env) {
        super('integrations', ServiceHandle.EVENT_SERVICE, http, env);
    }
    getIntegrationCourseLinks(fkSource, fkId, options) {
        return this.http.get(`${this.apiURL()}/${fkSource}/${fkId}/course_link`, options)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IntegrationsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IntegrationsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IntegrationsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class RsvpsApiService extends HttpClientService {
    constructor(http, env) {
        super('rsvps', ServiceHandle.EVENT_SERVICE, http, env);
    }
    getCertificatePdf(rsvpId, request) {
        return this.http.get(`${this.apiURL()}/${rsvpId}/certificate`, { responseType: 'blob' })
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RsvpsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RsvpsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RsvpsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class OrientationSessionsApiService extends HttpClientService {
    constructor(http, env) {
        super('orientation_sessions', ServiceHandle.EVENT_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OrientationSessionsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OrientationSessionsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OrientationSessionsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class FormsApiService extends HttpClientService {
    constructor(http, permissibleHttp, env) {
        super('forms', ServiceHandle.FORMS_SERVICE, http, env);
        this.permissibleHttp = permissibleHttp;
    }
    getFormJson(formId, params) {
        return this.http.get(`${this.apiURL()}/${formId}/json`, params)
            .pipe(this.catchHttpError());
    }
    getPermissibleFormJson(formId, params) {
        return this.permissibleHttp.get(`${this.apiURL()}/${formId}/json`, params)
            .pipe(this.catchHttpError());
    }
    completeForm(formId, body) {
        return this.http.post(`${this.apiURL()}/${formId}/complete`, body)
            .pipe(this.catchHttpError());
    }
    getAddBranchLink(personId, memberNrdsId, officeNrdsId, request) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        const url = `${this.apiURL()}/${'New Branch'}/form_link?person_id=${personId}&member_nrds_id=${memberNrdsId}&office_nrds_id=${officeNrdsId}`;
        return this.http.get(url, options)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormsApiService, deps: [{ token: i1.HttpClient }, { token: i2.PermissibleHttpService }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.PermissibleHttpService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class FormsAssociationSettingsApiService extends HttpClientService {
    constructor(http, env) {
        super('association_settings', ServiceHandle.FORMS_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormsAssociationSettingsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormsAssociationSettingsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormsAssociationSettingsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class ApplicationSessionDataApiService extends HttpClientService {
    constructor(http, env) {
        super('application_session_data', ServiceHandle.MEMBER_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationSessionDataApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationSessionDataApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationSessionDataApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class CategoriesApiService extends HttpClientService {
    constructor(http, env) {
        super('categories', ServiceHandle.MEMBER_SERVICE, http, env);
    }
    getCategoryOffices(request, categoryId) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${categoryId}/offices`, options).pipe(this.catchHttpError());
    }
    getOccupations(categoryId) {
        return this.http.get(`${this.apiURL()}/${categoryId}/occupations`)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CategoriesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CategoriesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CategoriesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class MemberApiService extends HttpClientService {
    constructor(http, env) {
        super('members', ServiceHandle.MEMBER_SERVICE, http, env);
    }
    getMember(memberNrdsId) {
        return this.http.get(`${this.apiURL()}/${memberNrdsId}`)
            .pipe(this.catchHttpError());
    }
    getMemberResponsibleAssociations(memberNrdsId, request) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        const url = `${this.apiURL()}/${memberNrdsId}/responsible_associations`;
        return this.http.get(url, options)
            .pipe(this.catchHttpError());
    }
    validateMemberSameOffice(paymentItemMemberNrdsId, reallocateMemberNrdsId) {
        const body = {
            payment_item_member_nrds_id: paymentItemMemberNrdsId,
            reallocate_member_nrds_id: reallocateMemberNrdsId
        };
        const url = `${this.apiURL()}/validate_same_office`;
        return this.http.post(url, body)
            .pipe(this.catchHttpError());
    }
    getMemberComplete(memberNrdsId) {
        return this.http.get(`${this.apiURL()}/${memberNrdsId}/complete`)
            .pipe(this.catchHttpError());
    }
    getMemberBoardsInCommon(memberNrdsId, officeNrdsId) {
        return this.http.get(`${this.apiURL()}/${memberNrdsId}/boards_in_common?office_nrds_id=${officeNrdsId}`)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class NrdsApiService extends HttpClientService {
    constructor(http, env) {
        super('nrds', ServiceHandle.MEMBER_SERVICE, http, env);
    }
    checkDuplicateEmail(memberNrdsId, email) {
        const url = this.apiURL() + `/members/${memberNrdsId}/check_duplicate_email?email=${email}`;
        return this.http.get(url);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NrdsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NrdsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NrdsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class OfficesApiService extends HttpClientService {
    constructor(http, env) {
        super('offices', ServiceHandle.MEMBER_SERVICE, http, env);
    }
    getOfficeRoster(officeNrdsId, request) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        const url = `${this.env.api.billing}/${this.apiPath}/${officeNrdsId}/roster`;
        return this.http.get(url, options)
            .pipe(this.catchHttpError());
    }
    getOffice(officeNrdsId, request) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${officeNrdsId}`, options).pipe(this.catchHttpError());
    }
    getOfficeForm(officeNrdsId, request) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${officeNrdsId}/form`, options)
            .pipe(this.catchHttpError());
    }
    updateOffice(officeNrdsId, body) {
        return this.http.put(`${this.apiURL()}/${officeNrdsId}/form`, body).pipe(this.catchHttpError());
    }
    refreshOffice(officeNrdsId) {
        return this.http.put(`${this.apiURL()}/${officeNrdsId}/refresh`, {}).pipe(this.catchHttpError());
    }
    getOfficeCorporateStructure(officeNrdsId, request) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${officeNrdsId}/corporate_structure`, options)
            .pipe(this.catchHttpError());
    }
    getOfficeCorporateStructureInformation(officeNrdsId, request) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${officeNrdsId}/corporate_structure_information`, options)
            .pipe(this.catchHttpError());
    }
    getRoles(officeNrdsId) {
        return this.http.get(`${this.env.api.billing}/${this.apiPath}/${officeNrdsId}/roster/roles`)
            .pipe(this.catchHttpError());
    }
    updateOfficeSupplemental(officeNrdsId, body) {
        return this.http.put(`${this.apiURL()}/${officeNrdsId}/office_supplemental`, body)
            .pipe(this.catchHttpError());
    }
    updateTangillaOffice(officeNrdsId, body) {
        return this.http.put(`${this.env.api.member}/tangilla_offices/${officeNrdsId}`, body)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OfficesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OfficesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OfficesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class OfficesPortalApiService extends HttpClientService {
    constructor(http, env) {
        super('offices_portal', ServiceHandle.MEMBER_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OfficesPortalApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OfficesPortalApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OfficesPortalApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class RpacYearApiService extends HttpClientService {
    constructor(http, env) {
        super('rpac_years', ServiceHandle.MEMBER_SERVICE, http, env);
    }
    getContributionSummaries(rpacYearId, request) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        const url = `${this.apiURL()}/${rpacYearId}/contribution_summaries`;
        return this.http.get(url, options)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RpacYearApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RpacYearApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RpacYearApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class RpacYearAssociationsApiService extends HttpClientService {
    constructor(http, env) {
        super('rpac_year_associations', ServiceHandle.MEMBER_SERVICE, http, env);
    }
    getRpacAssociationsRegions() {
        return this.http.get(`${this.apiURL()}/regions`)
            .pipe(this.catchHttpError());
    }
    getRpacAssociationsCategories() {
        return this.http.get(`${this.apiURL()}/categories`)
            .pipe(this.catchHttpError());
    }
    getRpacTrustees(rpacYearAssociationId) {
        return this.http.get(`${this.apiURL()}/${rpacYearAssociationId}/rpac_trustees`)
            .pipe(this.catchHttpError());
    }
    createRpacTrustee(rpacYearAssociationId, body, options) {
        return this.http.post(`${this.apiURL()}/${rpacYearAssociationId}/rpac_trustees`, body, options)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RpacYearAssociationsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RpacYearAssociationsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RpacYearAssociationsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class AssociationShortNamesApiService extends HttpClientService {
    constructor(http, env) {
        super('association_short_names', ServiceHandle.MEMBER_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AssociationShortNamesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AssociationShortNamesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AssociationShortNamesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class AssociationsApiService extends HttpClientService {
    constructor(http, env) {
        super('associations', ServiceHandle.MEMBER_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AssociationsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AssociationsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AssociationsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class RpacTrusteesApiService extends HttpClientService {
    constructor(http, env) {
        super('rpac_trustees', ServiceHandle.MEMBER_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RpacTrusteesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RpacTrusteesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RpacTrusteesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class FindOfficesApiService extends HttpClientService {
    constructor(http, env) {
        super('find_offices', ServiceHandle.MEMBER_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FindOfficesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FindOfficesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FindOfficesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class FindBrokerOfficesApiService extends HttpClientService {
    constructor(http, env) {
        super('find_broker_offices', ServiceHandle.MEMBER_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FindBrokerOfficesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FindBrokerOfficesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FindBrokerOfficesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class MemberPeopleApiService extends HttpClientService {
    constructor(http, env) {
        super('people', ServiceHandle.MEMBER_SERVICE, http, env);
    }
    getPersonCorporateStructureInformation(personId) {
        const url = `${this.env.api.member}/${this.apiPath}/${personId}/corporate_structure_information`;
        return this.http.get(url)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberPeopleApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberPeopleApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MemberPeopleApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class AssociationSettingsApiService extends HttpClientService {
    constructor(http, env) {
        super('association_settings', ServiceHandle.MEMBER_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AssociationSettingsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AssociationSettingsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AssociationSettingsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class ReportsApiService extends HttpClientService {
    constructor(http, reportingUtilsService, env) {
        super('reports', ServiceHandle.REPORTING_SERVICE, http, env);
        this.reportingUtilsService = reportingUtilsService;
    }
    runReport(reportId, body, options) {
        return this.http.post(`${this.apiURL()}/${reportId}`, body, options)
            .pipe(this.catchHttpError());
    }
    getPaginatedSavedReports(request, getAll, url, reportId) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        url = url ? url : `${this.apiURL()}/${reportId}/saved_reports`;
        return this.http.get(url, options)
            .pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = (await this.getPaginatedSavedReports(request, getAll, url).toPromise());
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    saveReport(body, reportId) {
        const url = `${reportId}/saved_reports`;
        return this.http.post(`${this.apiURL()}/${url}`, body);
    }
    updateReport(body, reportId) {
        const url = `${reportId}/saved_reports`;
        return this.http.put(`${this.apiURL()}/${url}`, body);
    }
    getSubscribers(savedReportId) {
        const url = `${savedReportId}/report_subscribers`;
        return this.http.get(`${this.apiURL()}/${url}`);
    }
    addFavorite(body) {
        const url = `${body.report_id}/favorites`;
        return this.http.post(`${this.apiURL()}/${url}`, body);
    }
    removeFavorite(reportId) {
        const url = `${reportId}/favorites`;
        return this.http.delete(`${this.apiURL()}/${url}`);
    }
    getParamValues(filterServiceParameters, reportId) {
        const url = `${this.apiURL()}/${reportId}/params/${filterServiceParameters.paramId}`;
        const formsQueryParamsString = `?association_nrds_id=${filterServiceParameters.associationId}&filter_values=${filterServiceParameters.dependeeFilterValues}`;
        return this.http.get(`${url}${formsQueryParamsString}`);
    }
    saveAsyncReport(body, reportId) {
        const url = `${reportId}/async_reports`;
        return this.http.post(`${this.apiURL()}/${url}`, body);
    }
    getAsyncReportFile(async_report_id, options) {
        const url = `async_reports/${async_report_id}`;
        return this.http.get(`${this.apiURL()}/${url}`, options)
            .pipe(this.catchHttpError());
    }
    deleteAsyncReport(async_report_id) {
        const url = `async_reports/${async_report_id}`;
        return this.http.delete(`${this.apiURL()}/${url}`)
            .pipe(this.catchHttpError());
    }
    getPaginatedAsyncReports(request, getAll, url) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        url = url ? url : `${this.apiURL()}/async_reports`;
        return this.http.get(url, options)
            .pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = (await this.getPaginatedAsyncReports(request, getAll, url).toPromise());
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ReportsApiService, deps: [{ token: i1.HttpClient }, { token: i2$1.ReportingUtilsService }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ReportsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ReportsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2$1.ReportingUtilsService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class ReportCategoriesApiService extends HttpClientService {
    constructor(http, env) {
        super('report_categories', ServiceHandle.REPORTING_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ReportCategoriesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ReportCategoriesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ReportCategoriesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class ApplicationReportsApiService extends HttpClientService {
    constructor(http, reportingUtilsService, env, projectConfig) {
        super(`applications/${projectConfig.applicationName}/reports`, ServiceHandle.REPORTING_SERVICE, http, env);
        this.reportingUtilsService = reportingUtilsService;
        this.projectConfig = projectConfig;
    }
    runReport(reportId, body, options) {
        return this.http.post(`${this.apiURL()}/${reportId}`, body, options)
            .pipe(this.catchHttpError());
    }
    getPaginatedSavedReports(request, getAll, url, reportId) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        url = url ? url : `${this.apiURL()}/${reportId}/saved_reports`;
        return this.http.get(url, options)
            .pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = (await this.getPaginatedSavedReports(request, getAll, url).toPromise());
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    saveReport(body, reportId) {
        const url = `${reportId}/saved_reports`;
        return this.http.post(`${this.apiURL()}/${url}`, body);
    }
    updateReport(body, reportId) {
        const url = `${reportId}/saved_reports`;
        return this.http.put(`${this.apiURL()}/${url}`, body);
    }
    getSubscribers(savedReportId) {
        const url = `${savedReportId}/report_subscribers`;
        return this.http.get(`${this.apiURL()}/${url}`);
    }
    addFavorite(body) {
        const url = `${body.report_id}/favorites`;
        return this.http.post(`${this.apiURL()}/${url}`, body);
    }
    removeFavorite(reportId) {
        const url = `${reportId}/favorites`;
        return this.http.delete(`${this.apiURL()}/${url}`);
    }
    getParamValues(filterServiceParameters, reportId) {
        const url = `${this.apiURL()}/${reportId}/params/${filterServiceParameters.paramId}`;
        const formsQueryParamsString = `?association_nrds_id=${filterServiceParameters.associationId}&filter_values=${filterServiceParameters.dependeeFilterValues}`;
        return this.http.get(`${url}${formsQueryParamsString}`);
    }
    saveAsyncReport(body, reportId) {
        const url = `${reportId}/async_reports`;
        return this.http.post(`${this.apiURL()}/${url}`, body);
    }
    getAsyncReportFile(async_report_id, options) {
        const url = `async_reports/${async_report_id}`;
        return this.http.get(`${this.apiURL()}/${url}`, options)
            .pipe(this.catchHttpError());
    }
    deleteAsyncReport(async_report_id) {
        const url = `async_reports/${async_report_id}`;
        return this.http.delete(`${this.apiURL()}/${url}`)
            .pipe(this.catchHttpError());
    }
    getPaginatedAsyncReports(request, getAll, url) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        url = url ? url : `${this.apiURL()}/async_reports`;
        return this.http.get(url, options)
            .pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = (await this.getPaginatedAsyncReports(request, getAll, url).toPromise());
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationReportsApiService, deps: [{ token: i1.HttpClient }, { token: i2$1.ReportingUtilsService }, { token: 'env' }, { token: 'projectConfig' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationReportsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationReportsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2$1.ReportingUtilsService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['projectConfig']
                }] }]; } });

class ApplicationReportCategoriesApiService extends HttpClientService {
    constructor(http, reportingUtilsService, env, projectConfig) {
        super(`applications/${projectConfig.applicationName}/report_categories`, ServiceHandle.REPORTING_SERVICE, http, env);
        this.reportingUtilsService = reportingUtilsService;
        this.projectConfig = projectConfig;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationReportCategoriesApiService, deps: [{ token: i1.HttpClient }, { token: i2$1.ReportingUtilsService }, { token: 'env' }, { token: 'projectConfig' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationReportCategoriesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ApplicationReportCategoriesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2$1.ReportingUtilsService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['projectConfig']
                }] }]; } });

class WebsiteFeedApiService extends HttpClientService {
    constructor(http, env) {
        super('website_feed', ServiceHandle.REPORTING_SERVICE, http, env);
    }
    getAssociationCourse(associationNrdsId, params) {
        return this.http.get(`${this.apiURL()}/${associationNrdsId}/course`, { params })
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: WebsiteFeedApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: WebsiteFeedApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: WebsiteFeedApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class AddressApiService extends HttpClientService {
    constructor(http, env) {
        super('address', ServiceHandle.UTILITIES_SERVICE, http, env);
    }
    validateAddress(params) {
        return this.http.get(`${this.apiURL()}/validate`, params).pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AddressApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AddressApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AddressApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class LicenseTypeLabelsApiService extends HttpClientService {
    constructor(http, env) {
        super('license_type_labels', ServiceHandle.UTILITIES_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LicenseTypeLabelsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LicenseTypeLabelsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LicenseTypeLabelsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class NrdsAssociationsApiService extends HttpClientService {
    constructor(http, env) {
        super('nrds/search/associations', ServiceHandle.UTILITIES_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NrdsAssociationsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NrdsAssociationsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NrdsAssociationsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class NrdsMembersApiService extends HttpClientService {
    constructor(http, env) {
        super('nrds/search/members', ServiceHandle.UTILITIES_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NrdsMembersApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NrdsMembersApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NrdsMembersApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class StatesApiService extends HttpClientService {
    constructor(http, env) {
        super('states', ServiceHandle.UTILITIES_SERVICE, http, env);
    }
    get lastLicenseSearch() {
        return this.licenseSearch;
    }
    set lastLicenseSearch(licenseSearchValue) {
        this.licenseSearch = licenseSearchValue;
    }
    get lastAffiliatedLicenseSearch() {
        return this.affiliatedLicenseSearch;
    }
    set lastAffiliatedLicenseSearch(licenseSearchValue) {
        this.affiliatedLicenseSearch = licenseSearchValue;
    }
    getStateLicense(state, licenseNumber, params) {
        return this.http.get(`${this.apiURL()}/${state}/licenses/${licenseNumber}`, params)
            .pipe(this.catchHttpError());
    }
    getPublicStateLicense(state, licenseNumber, params) {
        return this.http.get(`${this.apiURL()}/${state}/licenses/${licenseNumber}/public_license`, params)
            .pipe(this.catchHttpError());
    }
    createStateLicense(state, body) {
        return this.http.post(`${this.apiURL()}/${state}/licenses`, body)
            .pipe(this.catchHttpError());
    }
    getStateLicenseWithType(state, licenseNumber, licenseType, params) {
        return this.http.get(`${this.apiURL()}/${state}/licenses/${licenseNumber}/license_type/${licenseType}`, params)
            .pipe(this.catchHttpError());
    }
    updateStateLicense(state, licenseNumber, licenseType, body, params) {
        return this.http.put(`${this.apiURL()}/${state}/licenses/${licenseNumber}/license_type/${licenseType}`, body, params)
            .pipe(this.catchHttpError());
    }
    getStateLicenseNumberAllLicenses(state, licenseNumber, params) {
        return this.http.get(`${this.apiURL()}/${state}/licenses/${licenseNumber}/all_licenses`, params)
            .pipe(this.catchHttpError());
    }
    getStateLicenseNumberAffiliations(state, licenseNumber, params) {
        return this.http.get(`${this.apiURL()}/${state}/licenses/${licenseNumber}/affiliations`, params)
            .pipe(this.catchHttpError());
    }
    createUnreportedLicensee(state, licenseNumber, payload) {
        return this.http.post(`${this.apiURL()}/${state}/licenses/${licenseNumber}/unreported_licensees`, payload)
            .pipe(this.catchHttpError());
    }
    getPaginatedStateLicenseSponsorees(licenseState, licenseNumber, request) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${licenseState}/licenses/${licenseNumber}/sponsorees`, options)
            .pipe(this.catchHttpError());
    }
    getPaginatedLicenses(request, getAll, stateAbbreviation) {
        let options;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${stateAbbreviation}/licenses`, options)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StatesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StatesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StatesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class UtilitiesAssociationSettingsApiService extends HttpClientService {
    constructor(http, env) {
        super('association_settings', ServiceHandle.UTILITIES_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UtilitiesAssociationSettingsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UtilitiesAssociationSettingsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UtilitiesAssociationSettingsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class PortalConfigService {
    constructor() {
    }
    get portalConfig() {
        return this._portalConfig;
    }
    set portalConfig(value) {
        this._portalConfig = value;
    }
    colorConfig(index) {
        const colorIndex = (index < this._portalConfig.color_array.length) ? index : index % this._portalConfig.color_array.length;
        return {
            color: this._portalConfig.color_array[colorIndex],
            background_color: (this._portalConfig.color_array[colorIndex] + '1A')
        };
    }
    colorStatus(status) {
        return this._portalConfig.color_status[status]?.color;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PortalConfigService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PortalConfigService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PortalConfigService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return []; } });

class ColoredChipsUtilService {
    constructor(portalConfigService) {
        this.portalConfigService = portalConfigService;
    }
    formatToColoredChips(objectArray, keyProperty, labelProperty, iconProperty, colorProperty, categoryProperty, selectedProperty, chipDisabledFunction) {
        const coloredChipsArray = {};
        for (const [i, object] of objectArray.entries()) {
            coloredChipsArray[object[keyProperty || 'value']] = {
                selectable: true,
                label: object[labelProperty || 'label'],
                color: colorProperty ? this.portalConfigService.colorStatus(object[colorProperty]) : this.portalConfigService.colorConfig(i).color,
                icon: object[iconProperty] || undefined,
                category: object[categoryProperty] || undefined,
                selected: !!object[selectedProperty] || false,
                disabled: chipDisabledFunction ? chipDisabledFunction(object) : false,
            };
        }
        return coloredChipsArray;
    }
    getSelectedChipsKeys(coloredChips) {
        const selectedColoredChips = [];
        for (const eventType in coloredChips) {
            const eventTypeObject = coloredChips[eventType];
            if (eventTypeObject.selected) {
                selectedColoredChips.push(eventType);
            }
        }
        return selectedColoredChips;
    }
    getSelectedChips(chips) {
        const selectedChips = {};
        for (const key in chips) {
            if (chips[key].selected) {
                selectedChips[key] = chips[key];
            }
        }
        return selectedChips;
    }
    unselectChips(chips) {
        const unselectedChips = chips;
        for (const key in chips) {
            unselectedChips[key].selected = false;
        }
        return unselectedChips;
    }
    colorConfig(index) {
        return this.portalConfigService.colorConfig(index);
    }
    colorStatus(status) {
        return this.portalConfigService.colorStatus(status);
    }
    isItemSelected(itemValue, coloredChips) {
        const selectedItems = this.getSelectedChipsKeys(coloredChips);
        return selectedItems?.length === 0 || !!selectedItems.find(selectedItem => itemValue === selectedItem);
    }
    hasAnyItemSelected(itemsValuesArray, coloredChips) {
        const selectedItems = this.getSelectedChipsKeys(coloredChips);
        return selectedItems?.length === 0 || !!selectedItems.find(selectedItem => itemsValuesArray.find(itemValue => itemValue === selectedItem));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ColoredChipsUtilService, deps: [{ token: PortalConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ColoredChipsUtilService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ColoredChipsUtilService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: PortalConfigService }]; } });

class LicenseDataLookupApiService extends HttpClientService {
    constructor(http, env) {
        super('license_data_lookup', ServiceHandle.UTILITIES_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LicenseDataLookupApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LicenseDataLookupApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LicenseDataLookupApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class NrdsOfficesApiService extends HttpClientService {
    constructor(http, env) {
        super('nrds/search/offices', ServiceHandle.UTILITIES_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NrdsOfficesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NrdsOfficesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NrdsOfficesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class SlackMessagesApiService extends HttpClientService {
    constructor(http, env) {
        super('slack_messages', ServiceHandle.UTILITIES_SERVICE, http, env);
    }
    postSlackMessage(body) {
        return this.http.post(`${this.apiURL()}`, body)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SlackMessagesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SlackMessagesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SlackMessagesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class HelpdeskApiService extends HttpClientService {
    constructor(http, env) {
        super('helpdesk', ServiceHandle.UTILITIES_SERVICE, http, env);
    }
    submitFormTicket(body) {
        return this.http.post(`${this.apiURL()}/submit_form_helpdesk_ticket`, body)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HelpdeskApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HelpdeskApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HelpdeskApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class CheckForPendingBlockingJobQueueItems extends HttpClientService {
    constructor(http, env) {
        super('check_for_pending_blocking_job_queue_items', ServiceHandle.UTILITIES_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CheckForPendingBlockingJobQueueItems, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CheckForPendingBlockingJobQueueItems, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CheckForPendingBlockingJobQueueItems, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class FilterApiService extends HttpClientService {
    constructor(http, env) {
        super('filters', ServiceHandle$1.REPORTING_SERVICE, http, env);
    }
    getFilters(serviceHandle) {
        const url = `${this.apiServicePath(serviceHandle)}/${this.apiPath}`;
        return this.http.get(url).pipe(map$1((res) => res.filters));
    }
    getParamValues(filterServiceParameters) {
        let url = `${this.apiServicePath(filterServiceParameters.serviceHandle)}/${this.apiPath}/${filterServiceParameters.filterId}/${filterServiceParameters.paramId}`;
        const formsQueryParamsString = `?filter_values=${filterServiceParameters.dependeeFilterValues}`;
        url = `${url}${formsQueryParamsString}`;
        return this.http.get(url);
    }
    getFilter(serviceHandle, filterId) {
        const url = `${this.apiServicePath(serviceHandle)}/${this.apiPath}/${filterId}`;
        return this.http.get(url);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FilterApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FilterApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FilterApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class StateBillingEntitiesApiService extends HttpClientService {
    constructor(http, env) {
        super('billing_entities', ServiceHandle.STATE_EDUCATION_SERVICE, http, env);
    }
    getBillingEntityInstructorFees(request, getAll, billingEntityId) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${billingEntityId}/instructor_fees`, options).pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await firstValueFrom(this.getBillingEntityInstructorFees(request, getAll, billingEntityId));
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    getBillingEntityClasses(request, getAll, billingEntityId) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${billingEntityId}/course_classes`, options).pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await firstValueFrom(this.getBillingEntityClasses(request, getAll, billingEntityId));
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    getBillingEntityPurchasedPackages(request, getAll, billingEntityId) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${billingEntityId}/purchased_packages`, options).pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await firstValueFrom(this.getBillingEntityPurchasedPackages(request, getAll, billingEntityId));
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    getBillingEntityClassLocations(billingEntityId) {
        return this.http.get(`${this.apiURL()}/${billingEntityId}/class_locations`)
            .pipe(this.catchHttpError());
    }
    getCheckInstructorPayments(billingEntityId) {
        return this.http.get(`${this.apiURL()}/${billingEntityId}/check_instructor_payments`)
            .pipe(this.catchHttpError());
    }
    purchasePackage(billingEntityId, body) {
        return this.http.post(`${this.apiURL()}/${billingEntityId}/purchased_packages`, body)
            .pipe(this.catchHttpError());
    }
    createBillingEntityInstructorPayment(billingEntityId, body) {
        return this.http.post(`${this.apiURL()}/${billingEntityId}/instructor_payments`, body)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateBillingEntitiesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateBillingEntitiesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateBillingEntitiesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class StateEducationChargesApiService extends HttpClientService {
    constructor(http, env) {
        super('charges', ServiceHandle.STATE_EDUCATION_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateEducationChargesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateEducationChargesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateEducationChargesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class StateInstructorLicenseFeesApiService extends HttpClientService {
    constructor(http, env) {
        super('instructor_license_fees', ServiceHandle.STATE_EDUCATION_SERVICE, http, env);
    }
    getInstructorLicenseFeeCharges(instructorLicenseFeeId) {
        return this.http.get(`${this.apiURL()}/${instructorLicenseFeeId}/charges`)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateInstructorLicenseFeesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateInstructorLicenseFeesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateInstructorLicenseFeesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class StatePrepaidPackagesApiService extends HttpClientService {
    constructor(http, env) {
        super('prepaid_packages', ServiceHandle.STATE_EDUCATION_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StatePrepaidPackagesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StatePrepaidPackagesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StatePrepaidPackagesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class StateSubscriptionPackagesApiService extends HttpClientService {
    constructor(http, env) {
        super('subscription_packages', ServiceHandle.STATE_EDUCATION_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateSubscriptionPackagesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateSubscriptionPackagesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateSubscriptionPackagesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class StateSubscriptionBandsApiService extends HttpClientService {
    constructor(http, env) {
        super('subscription_bands', ServiceHandle.STATE_EDUCATION_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateSubscriptionBandsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateSubscriptionBandsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateSubscriptionBandsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class StateCourseClassesApiService extends HttpClientService {
    constructor(http, env) {
        super('course_classes', ServiceHandle.STATE_EDUCATION_SERVICE, http, env);
    }
    getCourseClassLoads(request, courseClassId, getAll) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${courseClassId}/course_class_loads`, options).pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await firstValueFrom(this.getCourseClassLoads(request, courseClassId, getAll));
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    getCourseClassLoadsCharges(courseClassId, body) {
        return this.http.post(`${this.apiURL()}/${courseClassId}/course_class_loads/charges`, body)
            .pipe(this.catchHttpError());
    }
    getCourseClassLoadsValidateLicenses(courseClassId, body) {
        return this.http.post(`${this.apiURL()}/${courseClassId}/course_class_loads/validate_licenses`, body)
            .pipe(this.catchHttpError());
    }
    createCourseClassLoads(courseClassId, body) {
        return this.http.post(`${this.apiURL()}/${courseClassId}/course_class_loads`, body)
            .pipe(this.catchHttpError());
    }
    getCourseClassInvoices(request, courseClassId, getAll) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${courseClassId}/invoices`, options).pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await firstValueFrom(this.getCourseClassInvoices(request, courseClassId, getAll));
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateCourseClassesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateCourseClassesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateCourseClassesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class StateInstructorsApiService extends HttpClientService {
    constructor(http, env) {
        super('instructors', ServiceHandle.STATE_EDUCATION_SERVICE, http, env);
    }
    getInstructorLicenseFeesCharges(instructorId, instructorLicenseFeeId) {
        return this.http.post(`${this.apiURL()}/${instructorId}/instructor_license_fees/${instructorLicenseFeeId}/charges`, {})
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateInstructorsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateInstructorsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateInstructorsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class StatePurchasedPackagesApiService extends HttpClientService {
    constructor(http, env) {
        super('purchased_packages', ServiceHandle.STATE_EDUCATION_SERVICE, http, env);
    }
    getPurchasedPackageCharges(body) {
        return this.http.post(`${this.apiURL()}/charges`, body)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StatePurchasedPackagesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StatePurchasedPackagesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StatePurchasedPackagesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class StateCalendarItemsApiService extends HttpClientService {
    constructor(http, env) {
        super('calendar_items', ServiceHandle.STATE_EDUCATION_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateCalendarItemsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateCalendarItemsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateCalendarItemsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class StateBroadcastClassesApiService extends HttpClientService {
    constructor(http, env) {
        super('broadcast_classes', ServiceHandle.STATE_EDUCATION_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateBroadcastClassesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateBroadcastClassesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateBroadcastClassesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class StateSubscriptionClassesApiService extends HttpClientService {
    constructor(http, env) {
        super('course_classes', ServiceHandle.STATE_EDUCATION_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateSubscriptionClassesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateSubscriptionClassesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateSubscriptionClassesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class StateClassDetailsApiService extends HttpClientService {
    constructor(http, env) {
        super('class_details', ServiceHandle.STATE_EDUCATION_SERVICE, http, env);
    }
    createClassDetailCourseClass(classDetailId, body) {
        return this.http.post(`${this.apiURL()}/${classDetailId}/course_classes`, body)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateClassDetailsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateClassDetailsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateClassDetailsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class StateCoursesApiService extends HttpClientService {
    constructor(http, env) {
        super('courses', ServiceHandle.STATE_EDUCATION_SERVICE, http, env);
    }
    downloadPDF(courseId) {
        return this.http.get(`${this.apiURL()}/${courseId}/download`, { responseType: 'blob' })
            .pipe(this.catchHttpError());
    }
    getSelfManagedClassPrice(courseId, year) {
        return this.http.get(`${this.apiURL()}/${courseId}/self_managed_price?start_year=${year}`)
            .pipe(this.catchHttpError());
    }
    getUpToDateInstructors(request, courseId, getAll) {
        let options = undefined;
        if (request) {
            options = { params: request.toHttpParams() };
        }
        return this.http.get(`${this.apiURL()}/${courseId}/up_to_date_instructors`, options).pipe(mergeMap(async (data) => {
            if (getAll && request) {
                let otherPagesData;
                request.offset += request.limit;
                if (data.total_items > request.limit &&
                    data.total_items > request.offset) {
                    otherPagesData = await firstValueFrom(this.getUpToDateInstructors(request, courseId, getAll));
                }
                if (otherPagesData) {
                    data.items.push(...otherPagesData.items);
                }
            }
            return data;
        }))
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateCoursesApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateCoursesApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateCoursesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class StateUpToDateInstructorsApiService extends HttpClientService {
    constructor(http, env) {
        super('up_to_date_instructors', ServiceHandle.STATE_EDUCATION_SERVICE, http, env);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateUpToDateInstructorsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateUpToDateInstructorsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateUpToDateInstructorsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class ClassmarkerApiService extends HttpClientService {
    constructor(http, env) {
        super('classmarker', ServiceHandle.STATE_EDUCATION_SERVICE, http, env);
    }
    getTestQuiz(associationNRDSId, testId) {
        return this.http
            .get(`${this.apiURL()}/associations/${associationNRDSId}/tests/${testId}/quiz`)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ClassmarkerApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ClassmarkerApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ClassmarkerApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

class StateCourseClassLoadsApiService extends HttpClientService {
    constructor(http, env) {
        super('course_class_loads', ServiceHandle.STATE_EDUCATION_SERVICE, http, env);
    }
    retryCourseClassLoads(courseClassLoadId) {
        return this.http.post(`${this.apiURL()}/${courseClassLoadId}/state_push`, null)
            .pipe(this.catchHttpError());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateCourseClassLoadsApiService, deps: [{ token: i1.HttpClient }, { token: 'env' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateCourseClassLoadsApiService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateCourseClassLoadsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['env']
                }] }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { AddendumsApiService, AddressApiService, AmendmentsApiService, ApplicationReportCategoriesApiService, ApplicationReportsApiService, ApplicationSessionDataApiService, ApplicationsApiService, AssociationPaymentItemsApiService, AssociationPaymentsApiService, AssociationSettingsApiService, AssociationShortNamesApiService, AssociationsApiService, AttendancesApiService, AuthApiService, BeanCounterInvoicesApiService, BillingAssociationSettingsApiService, BillingEntitiesApiService, BillingEntityUsersApiService, BillingOfficesApiService, BookingsApiService, BundlesApiService, CalendarEventsApiService, CategoriesApiService, CheckForPendingBlockingJobQueueItems, ClassmarkerApiService, ColoredChipsUtilService, CommitteesApiService, CommitteesPeopleApiService, ContributionsApiService, CoursesApiService, CoursesOnDemandApiService, CreditRequestsApiService, CustomersApiService, DriversApiService, EmailApiService, EventBillingTypesApiService, EventPeopleApiService, EventsApiService, EventsAssociationSettingsApiService, FilterApiService, FindBrokerOfficesApiService, FindOfficesApiService, FindPersonApiService, FormsApiService, FormsAssociationSettingsApiService, FormsBillingApiService, GeneralLedgersApiService, HelpdeskApiService, IncidentsApiService, IntegrationsApiService, InvoicesApiService, ItemTypesApiService, LicenseDataLookupApiService, LicenseTypeLabelsApiService, LocalAssociationsApiService, MeetingsApiService, MemberApiService, MemberPeopleApiService, MsasApiService, NonInvoicedProductsApiService, NrdsApiService, NrdsAssociationsApiService, NrdsMembersApiService, NrdsOfficesApiService, OfficeMembersApiService, OfficeRosterApiService, OfficesApiService, OfficesPortalApiService, OptoutsApiService, OrientationSessionsApiService, PaymentApiService, PaymentMethodsApiService, PeopleApiService, PeopleLookupApiService, PortalConfigApiService, PortalConfigService, PortalFormsApiService, PortalMessagesApiService, PortalTilesApiService, PreparedPaymentInvoicesApiService, PreparedPaymentsApiService, ProductConfigNonInvoicedProductsApiService, ProductTypeCatalogApiService, ProductsApiService, ProvisioningApiService, RecnTransactionApiService, RelationshipsApiService, ReportCategoriesApiService, ReportsApiService, RpacTrusteesApiService, RpacYearApiService, RpacYearAssociationsApiService, RsvpsApiService, SessionApiService, SlackMessagesApiService, StateBillingEntitiesApiService, StateBroadcastClassesApiService, StateCalendarItemsApiService, StateClassDetailsApiService, StateCourseClassLoadsApiService, StateCourseClassesApiService, StateCoursesApiService, StateEducationChargesApiService, StateInstructorLicenseFeesApiService, StateInstructorsApiService, StatePrepaidPackagesApiService, StatePurchasedPackagesApiService, StateSubscriptionBandsApiService, StateSubscriptionClassesApiService, StateSubscriptionPackagesApiService, StateUpToDateInstructorsApiService, StatesApiService, SubscriptionsApiService, TermsApiService, UnreportedLicenseesApiService, UnsubscribeApiService, UserApiService, UserClassOverridesApiService, UtilitiesAssociationSettingsApiService, ValidateDuesPaymentsApiService, ValidateMemberNRDSIDApiService, WebsiteFeedApiService, XeroContactsApiService };
